import React from 'react';
const RichTextTableCaption = ({ children }) => (React.createElement("caption", { className: "sr-only" }, children));
RichTextTableCaption.displayName = 'RichTextTableCaption';
export default RichTextTableCaption;
//# sourceMappingURL=TableCaption.js.map